<template>
  <div>
    <customize-page
      label-position="left"
      ref="page"
      inline
      :loading="loading"
      :data="dataList"
      :columns="columns"
      :pagination="pagination"
      :formConfig="getFormConfig()"
      :filterObj="filterObj"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
      <div slot="footer">
        <el-button style="margin-right: 10px" type="primary" @click="search">
          搜索
        </el-button>
        <el-button style="margin-right: 10px" @click="reset">重置</el-button>
        <el-button
          style="margin-right: 10px"
          type="primary"
          v-hp="'add'"
          @click="showAddOrModifyView(null)"
        >
          新增
        </el-button>
      </div>
    </customize-page>

    <el-dialog
      :title="(formData.isAdd === '' ? '新增' : '修改') + '申报企业'"
      width="450px"
      :visible.sync="showFormDialog"
    >
      <el-form
        style="width: 400px; margin: 0 auto"
        ref="form"
        :model="formData"
        label-width="120px"
      >
        <el-form-item label="企业名">
          <el-input v-model="formData.enterpriseName"></el-input>
        </el-form-item>
        <el-form-item label="企业标识">
          <el-input
            :disabled="!formData.isAdd"
            v-model="formData.enterpriseNid"
          ></el-input>
        </el-form-item>
        <el-form-item label="海关备案编码">
          <el-input v-model="formData.enterpriseCustomsCode"></el-input>
        </el-form-item>
        <el-form-item label="企业信用编号">
          <el-input v-model="formData.creditCode"></el-input>
        </el-form-item>
        <el-form-item label="海关备案名">
          <el-input v-model="formData.enterpriseCustomsName"></el-input>
        </el-form-item>
        <el-form-item label="企业类型">
          <el-select
            :disabled="!formData.isAdd"
            v-model="formData.enterpriseType"
          >
            <el-option
              v-for="item in enterpriseTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="formData.memo"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="save()">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import CustomizePage from "@/components/customize-page";
import Page from "@/mixin/Page";

import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    CustomizePage,
  },
  mixins: [Page],
  created() {
    this.defaultFormData = JSON.stringify(this.formData);
  },
  mounted() {
    this.fetch();
  },
  data() {
    return {
      loading: false,
      dataList: [],
      showFormDialog: false,
      defaultFormData: "",
      enterpriseTypeList: [
        { value: "E_ECOMMERCE", label: "电商企业" },
        { value: "P_ECOMMERCE", label: "电商平台" },
        { value: "E_LOGISTICS", label: "物流企业" },
        { value: "E_PAY", label: "支付企业" },
      ],
      formData: {
        isAdd: true,
        modifier: "",
        enterpriseNid: "",
        enterpriseType: "",
        enterpriseName: "",
        enterpriseCustomsCode: "",
        enterpriseCustomsName: "",
        creditCode: "",
        memo: "",
      },
      columns: [
        {
          type: "selection",
          width: 50,
          align: "center",
        },
        {
          title: "企业名",
          minWidth: 300,
          key: "enterpriseName",
          align: "center",
        },
        {
          title: "企业标识",
          width: 160,
          key: "enterpriseNid",
          align: "center",
        },
        {
          title: "企业类型",
          width: 90,
          key: "enterpriseType",
          align: "center",
        },
        {
          title: "企业社会信用代码",
          width: 120,
          key: "creditCode",
          align: "center",
        },
        {
          title: "海关备案编码",
          width: 120,
          key: "enterpriseCustomsCode",
          align: "center",
        },
        {
          title: "海关备案名",
          minWidth: 300,
          key: "enterpriseCustomsName",
          align: "center",
        },
        {
          title: "备注",
          width: 200,
          key: "memo",
          align: "center",
        },
        {
          title: "创建时间",
          width: 180,
          key: "gmtCreate",
          align: "center",
        },

        {
          title: "修改人",
          width: 160,
          key: "modifier",
          align: "center",
        },
        /*  {
						title: "修改时间",
						width: 180,
						key: "gmtModified",
						align: "center"
					},*/
        {
          title: "操作",
          width: 180,
          align: "center",
          fixed: "right",
          render: (h, param) => {
            let data = param.row;
            let operation = [];
            if (this.$hasPermission(this.$route, "edit")) {
              operation.push(
                <a
                  style="color:blue"
                  onClick={this.showAddOrModifyView.bind(this, data)}
                >
                  编缉
                </a>
              );
            }
            return operation;
          },
        },
      ],
      filterObj: {
        enterpriseNid: "",
        enterpriseName: "",
        enterpriseType: "",
      },
      currentRow: [],
      sortObj: {},
    };
  },
  computed: {
    ...mapGetters({
      userInfo: "user",
    }),
  },
  methods: {
    ...mapActions("declareEnterpriseStore", {
      list: "listDeclareEnterprise",
      add: "add",
      edit: "edit",
    }),
    fetch() {
      this.loading = true;
      const filterParams = this.getFilterParams();
      const sortObj = this.sortObj;
      let searchCondition = {
        ...sortObj,
        request: JSON.stringify({
          ...filterParams,
          pageInfo: {
            currentPage: this.pagination.currentPage,
            pageSize: this.pagination.pageSize,
          },
        }),
      };

      this.list(searchCondition)
        .then((res) => {
          this.loading = false;
          this.dataList = res.items || [];
          const pageInfo = res.pageInfo || { totalCount: 0 };
          this.pagination.totalCount = pageInfo.totalCount;
        })
        .catch((error) => {
          this.loading = false;
          this.$message.error("异常");
        });
    },
    showAddOrModifyView(data) {
      if (data != null) {
        this.formData.isAdd = false;
        this.formData.enterpriseNid = data.enterpriseNid;
        this.formData.enterpriseName = data.enterpriseName;
        this.formData.enterpriseCustomsName = data.enterpriseCustomsName;
        this.formData.enterpriseCustomsCode = data.enterpriseCustomsCode;
        this.formData.enterpriseType = data.enterpriseType;
        this.formData.memo = data.memo;
      } else {
        this.formData = JSON.parse(this.defaultFormData);
      }
      this.showFormDialog = !this.showFormDialog;
    },
    save() {
      this.formData.modifier = this.userInfo.nick;
      let param = { request: JSON.stringify(this.formData) };
      let operationFunction;
      if (this.formData.isAdd) {
        operationFunction = this.add(param);
      } else {
        operationFunction = this.edit(param);
      }
      operationFunction
        .then((res) => {
          if (res.value) {
            this.showFormDialog = !this.showFormDialog;
            this.fetch();
            this.$message.success("保存成功");
          } else {
            this.$message.error("保存失败");
          }
        })
        .catch((error) => {
          this.$message.error(error.msg || "未知异常");
        });
    },
    getFormConfig() {
      const type = this.getFormItemType();
      return [
        {
          data: [
            {
              label: "企业名",
              model: "enterpriseName",
              type: type.INPUT,
            },
            {
              label: "企业标识",
              model: "enterpriseNid",
              type: type.INPUT,
            },
            {
              label: "企业类型",
              model: "enterpriseType",
              type: type.SELECT,
              props: {
                data: [...this.enterpriseTypeList],
              },
            },
          ],
        },
      ];
    },
  },
};
</script>
